import { CaseStatus } from "@/store/baseClientApi";

export const designTableConstants = {
  POLLING_INTERVAL: 5000, // milliseconds
  DEFAULT_PER_PAGE: 10
};

export const CASE_TABLE_STATE_NAME = "caseTable";
export const CASE_TABLE_SORT_FIELDS = ["name", "status", "created_at"];

export const TabPath = "cases";
export const DefaultTab = "all";

export const caseStatuses: CaseStatus[] = [
  "pending_upload",
  "uploaded",
  "files_converted",
  "preprocessed",
  "failed",
  "done",
  "downloaded",
  "rejected",
  "unpaid_upload"
];

export const ALL_CASES_FILTER: CaseStatus[] = [
  "uploaded",
  "files_converted",
  "preprocessed",
  "failed",
  "done",
  "downloaded",
  "rejected",
  "unpaid_upload"
];
export const ISSUES_FILTER: CaseStatus[] = ["failed", "unpaid_upload"];
export const DESIGNED_FILTER: CaseStatus[] = ["done"];
export const DOWNLOADED_FILTER: CaseStatus[] = ["downloaded"];
export const REJECTED_FILTER: CaseStatus[] = ["rejected"];

export const STATUS_FILTERS: Record<string, any[]> = {
  all: ALL_CASES_FILTER,
  issues: ISSUES_FILTER,
  designed: DESIGNED_FILTER,
  downloaded: DOWNLOADED_FILTER,
  rejected: REJECTED_FILTER
};

export const ADDITIONAL_FILTERS: Record<string, string> = {
  issues: "(status:done AND event_log.status:warning)"
};
